<template lang="pug">
  div(:class="themeClass")
    .sort-area
      .sort-area-inner
        span.count
          | 求人リスト
          | {{ Number(total).toLocaleString() }}件
        .sort-link
          select(v-model="order")
            option(v-for="option in options" :value="option.value") {{ option.text }}
        .sort-btn-wrapper
          a.open-search-button(@click="toggleSidebar") 検索条件
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        options: [
          { text: 'ソート順指定なし', value: '' },
          { text: 'リスト更新日時(降順)', value: 'updated_at:desc' },
          { text: 'リスト更新日時(昇順)', value: 'updated_at:asc' },
          { text: 'リスト追加日時(降順)', value: 'created_at:desc' },
          { text: 'リスト追加日時(昇順)', value: 'created_at:asc' },
        ],
      }
    },
    computed: {
      ...mapState({
        total: state => state.jobList.pagination.totalCount,
        order: state => state.searchJobList.query.order,
      }),
      order: {
        get () {
          return this.$store.state.searchJobList.query.order
        },
        set (value) {
          this.$store.commit('searchJobList/order', value)
        },
      },
      themeClass () {
        if (location.hostname.includes('mynavi')) return 'theme-mynavi'
      },
    },
    watch: {
      order () {
        this.$emit('searchOrderBy', this.order)
      },
    },
    methods: {
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobListSortArea.vue